import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusGlow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 670 152"
    fill="none"
    {...props}
  >
    <g clipPath="url(#status-glow-clip)">
      <g filter="url(#status-glow-blur)">
        <ellipse cx={341} cy={-13} rx={415} ry={73} fill="#D5FFCF" />
      </g>
    </g>
    <defs>
      <filter
        id="status-glow-blur"
        x={-174}
        y={-186}
        width={1030}
        height={346}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation={50} result="status-glow-blur-effect" />
      </filter>
      <clipPath id="status-glow-clip">
        <rect width={670} height={152} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStatusGlow;
